import React from 'react';
import styled from '@mui/material/styles/styled';
import { TableRow } from '@mui/material';
var TableRowRoot = styled(TableRow)(function (_a) {
    var index = _a.index, onClick = _a.onClick;
    return {
        position: 'relative',
        cursor: onClick ? "pointer" : "default",
        '&:hover': {
            backgroundColor: '#f4f4f4'
        },
        backgroundColor: index % 2 === 0 ? '#fff' : '#FAFAFA',
        '& td[type="actions"]': {
            opacity: 0,
            transition: 'opacity 0.06s'
        },
        '&:hover td[type="actions"]': {
            opacity: 1
        }
    };
});
var TbodyRow = function (_a) {
    var children = _a.children, index = _a.index, onClick = _a.onClick;
    return (React.createElement(TableRowRoot, { index: index, onClick: onClick }, children));
};
export default TbodyRow;
